// extracted by mini-css-extract-plugin
export default {"key":"ProjectInfoModal_key__r177b","generalInfo":"ProjectInfoModal_generalInfo__Wbiqx","lockIcon":"ProjectInfoModal_lockIcon__Ew4Vg"};